import {Component, EventEmitter, Input, Output} from "@angular/core";
import {EditGridReorderEvent} from "../edit-grid-reorder-event";
import {AnalyticsService} from "../../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../../analytics/analytic-event";
import {EditGridService} from "../edit-grid.service";

@Component({
    selector: "wbo-edit-grid-reorder-buttons",
    templateUrl: "edit-grid-reorder-buttons.component.html",
    styleUrls: ["./edit-grid-reorder-buttons.component.scss"],
})
export class EditGridReorderButtonsComponent {

    @Input() rowIndex: number;
    @Output() reordering: EventEmitter<EditGridReorderEvent> = new EventEmitter<EditGridReorderEvent>();

    constructor(private editGridService: EditGridService, private analyticsService: AnalyticsService) {
    }

    get isUpEnabled(): boolean {
        return this.rowIndex > 0;
    }

    get isDownEnabled(): boolean {
        return this.rowIndex < this.editGridService.data.length - 1;
    }

    moveUp(): void {
        this.reordering.emit(new EditGridReorderEvent(this.rowIndex, this.rowIndex - 1));
        const record: any = this.editGridService.data[this.rowIndex - 1];
        this.editGridService.data[this.rowIndex - 1] = this.editGridService.data[this.rowIndex];
        this.editGridService.data[this.rowIndex] = record;
        this.editGridService.refreshGridData();
        this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_MOBILE_REORDERING);
    }

    moveDown(): void {
        this.reordering.emit(new EditGridReorderEvent(this.rowIndex, this.rowIndex + 1));
        const record: any = this.editGridService.data[this.rowIndex + 1];
        this.editGridService.data[this.rowIndex + 1] = this.editGridService.data[this.rowIndex];
        this.editGridService.data[this.rowIndex] = record;
        this.editGridService.refreshGridData();
        this.analyticsService.trackEvent(AnalyticEvent.ENTITY_INTERACTION_GRID_MOBILE_REORDERING);
    }
}
